var magicStyles = [" [data-v-d5a8751a-host],:host {\n  display: contents;\n}\n.list[data-v-d5a8751a] {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0 var(--magic-space, 16px);\n  width: 100%;\n}"];

export default magicStyles;
